import insightsClient from 'search-insights'
import { getCookie } from '@/helpers/cookies'

export const algoliaAppId = 'ML35QLWPOC'
export const algoliaKey = 'bff229776989d153121333c90db826b1'
export const ENVS_WITHOUT_EVENTS = ['staging', 'development']
export const isTrackingDisabled = ENVS_WITHOUT_EVENTS.includes(process.env.TARGET_ENV)

const uuid = getCookie('on_uuid')

insightsClient('init', {
  appId: algoliaAppId,
  apiKey: algoliaKey,
})
insightsClient('setUserToken', uuid)

export const algoliaInsightsClient = insightsClient
